import React from 'react'
import ReactDOM from 'react-dom/client'
import LandingPage from './LandingPage/LandingPage'
import './index.css'
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import {Auth0Provider} from '@auth0/auth0-react';
import SelectApp from './Login/SelectApp';
import RegisterPage from './Login/RegisterPage';

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

function Auth0ProviderWithNavigate({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate();

    return (
        <Auth0Provider
            domain={domain ?? ""}
            clientId={clientId ?? ""}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience,
            }}
            onRedirectCallback={(appState) => {
                navigate(appState?.returnTo ?? "/select-app", { replace: true });
            }}
        >
            {children}
        </Auth0Provider>
    );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <Auth0ProviderWithNavigate>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/select-app" element={<SelectApp />} />
                    <Route path="/register" element={<RegisterPage />} />
                </Routes>
            </Auth0ProviderWithNavigate>
        </BrowserRouter>
    </React.StrictMode>,
)
